/** @format */

import {useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import * as React from "react";
import {
  EVENT_HEADER
} from "../../helpers/Constants";
// import CustomCard from "../../sections/CustomCard";
import CustomTable from "./CustomTable";



function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: '100%' }} // Added this line to make the panel 100% width
    >
      {value === index && <Box sx={{ py: "16px" }}>{children}</Box>}
    </div>
  );
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);
  const isMobile = useMediaQuery("(max-width:768px)");
  const isDesktop = !isMobile;
  const { active, reviewed, cleared, totalNCACount } = props;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  return (
    <>

      <Box sx={{ width: "100%" }}>
        <CustomTabPanel value={value} index={0}>
          <CustomTable
            data={props}
            columns={EVENT_HEADER}
            sortableColumns={[
              "eventId",
              "eventName",
              "eventLocation",
              "client",
              "note",
              "eventDate",
            ]}
            pageSize={5}
            routing="/AddEditEvent"
            eventUserListRouting="/EventUserList"
            tabData={props?.events?.$values}
            downloadIconEnabled={false}
            filesIconEnabled={false}
            actionTabEnabled={true}
            ActivePendingIconEnabled={false}
            EditEnabled={true}
            AddEnabled={true}
            NotesEnabled={true}
            CheckBoxEnabled={false}
            DeleteEnabled={true}
            EventStartEnabled={true}
            UserListEnabled={true}
            skip={0}
            getStormInfoEnabled={true}
            tab="active"
            sx={{ width: "100%" }} // Added this line to make the table 100% width
          />
        </CustomTabPanel>
      </Box>
    </>
  );
}
